export const INSERT_CAMPAIGN_MUTATION = `
  mutation InsertCampaign($input: CampaignInsertInput!) {
    insertCampaign(input: $input) {
      acknowledged
      itemId
      totalImpactedData
      message
    }
  }
`;

export const UPDATE_CAMPAIGN_MUTATION = `
  mutation UpdateCampaign(
    $where: CampaignFilterInput!
    $input: CampaignUpdateInput!
  ) {
    updateCampaign(where: $where, input: $input) {
      acknowledged
      itemId
      totalImpactedData
      message
    }
  }
`;

export const INSERT_CAMPAIGN_SEGMENT_MUTATION = `
  mutation InsertCampaignSegment($input: CampaignSegmentInsertInput!) {
    insertCampaignSegment(input: $input) {
      acknowledged
      itemId
      totalImpactedData
      message
    }
  }
`;

export const UPDATE_CAMPAIGN_SEGMENT_MUTATION = `
  mutation UpdateCampaignSegment(
    $where: CampaignSegmentFilterInput!
    $input: CampaignSegmentUpdateInput!
  ) {
    updateCampaignSegment(where: $where, input: $input) {
      acknowledged
      itemId
      totalImpactedData
      message
    }
  }
`;
